import Repository from "./Repository";
import { glueParamsToUrl } from "commonjs/helpers";
export default {
    getBlogPosts(page = 1) {
        return Repository.get(`/blogPostsAllPublicPaginated?page=${page}`);
    },
    getBlogPostsQuery(params) { //Needed to add this in order to have getBlogPosts as legacy       
        let url = glueParamsToUrl("/blogPostsAllPublicPaginated", params);
        return Repository.get(url);
    },
    getBlogPostTemplates(query) {
        if (!query) {
            query = {};
        }

        let params = {};
        if (query.site_template) {
            params.site_template = query.site_template;
        }

        let url = '/blogPostTemplates';
        var queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');


        return Repository.get(url + '?' + queryString);
    },
    getBlogPost(slug, params) {
        let url = glueParamsToUrl(`/blogPost/${slug}`, params);
        return Repository.get(url);
    },
    saveBlogPost(slug, postData, params) {
        let url = glueParamsToUrl(`/blogPost/${slug}`, params);
        return Repository.post(url, postData);
    },
    saveBlogPostSeo(slug, pageSeo, params) {
        let url = glueParamsToUrl(`/blogPost/${slug}`, params);
        return Repository.post(url, pageSeo);
    },
    deleteBlogPost(slug, params) {
        let url = glueParamsToUrl(`/blogPost/${slug}`, params);
        return Repository.delete(url);
    },
    cloneBlogPost(payload, params) {
        const {originalSlug, cloneData} = payload;
        let url = glueParamsToUrl(`/blogPost/${originalSlug}/clone`, params);
        if (!cloneData) {
            return Repository.post(url);
        }

        return Repository.post(url, cloneData);
    },
    createBlogPost(data) {
        return Repository.post(`/blogPost`, data);
    },
    getBlogPostsCategories() {
        return Repository.get(`/blogPostsCategories?search`);
    },
    blogPosts(params) {
        let url = glueParamsToUrl("/blogPosts", params);
        return Repository.get(url);
    },
    exportBlogPostTemplates() {
        return Repository({
            url: `${window.api}blogPosts/templates/export?${window.oauthInfo}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((blob) => {
            if (blob.data.type === 'application/json') {
                return blob.data.text().then((textResponse) => {
                    const data = JSON.parse(textResponse)
                    console.log(data)
                    return Promise.reject(data.errors)
                })
            }

            const url = window.URL.createObjectURL(new Blob([blob.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `blog_post_templates.zip`);
            document.body.appendChild(link);
            link.click();
        });
    }
}
